var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartitionLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.1249 73.9382C49.5332 75.4334 45.2469 75.3337 42.4558 73.7388L27.0052 64.7675C24.3138 63.1726 24.1145 60.6806 26.7062 59.1854C29.2979 57.6901 33.5842 57.7898 36.3753 59.3847L51.8259 68.3561C54.617 69.951 54.7166 72.443 52.1249 73.9382Z",
    fill: "url(#paint0_linear_1352_358854)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.324 11.1668C17.5666 13.279 15.1876 18.2592 15.1876 25.3628C15.1876 38.2358 23.0137 53.1988 32.6741 58.7683V12.1451C28.3386 9.64383 24.3811 9.45485 21.324 11.1668Z",
    fill: "#DBDFE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0951 6.10871L30.0284 6.14206C29.9951 6.1643 29.9728 6.17541 29.9395 6.19765L21.3352 11.1668C24.3923 9.45483 28.3498 9.64381 32.6853 12.1451L41.423 7.0981C37.0986 4.60797 33.1411 4.40787 30.0951 6.10871Z",
    fill: "#DBDFE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6741 12.145V58.7682L41.4229 53.7212V7.09802L32.6741 12.145Z",
    fill: "#DBDFE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.324 11.1668C17.5666 13.279 15.1876 18.2592 15.1876 25.3628C15.1876 38.2358 23.0137 53.1988 32.6741 58.7683V12.1451C28.3386 9.64383 24.3811 9.45485 21.324 11.1668Z",
    fill: "#D7D7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0839 6.10871L30.0172 6.14206C29.9838 6.1643 29.9616 6.17541 29.9283 6.19765L21.324 11.1668C24.3811 9.45483 28.3386 9.64381 32.6741 12.1451L41.4118 7.0981C37.0874 4.60797 33.1299 4.40787 30.0839 6.10871Z",
    fill: "url(#paint1_linear_1352_358854)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6741 12.145V58.7682L41.4229 53.7212V7.09802L32.6741 12.145Z",
    fill: "url(#paint2_linear_1352_358854)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2576 59.613C41.1783 61.4695 37.1207 61.3361 32.6852 58.7681V35.4565L44.2576 59.613Z",
    fill: "#B9B9B9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2576 59.6131L32.6741 35.4566L41.4229 30.4097L52.9953 54.5661L44.2576 59.6131Z",
    fill: "#B9B9B9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2576 59.6131C41.1783 61.4696 37.1207 61.3362 32.6852 58.7683V35.4567L44.2576 59.6131Z",
    fill: "#D7D7D7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2354 59.5131L32.6519 35.3566L41.3895 30.3097L52.9731 54.4662L44.2354 59.5131Z",
    fill: "url(#paint3_linear_1352_358854)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0635 51.6759C56.0635 58.635 53.7735 63.5596 50.1495 65.7385L38.577 41.582L56.0635 51.6759Z",
    fill: "#878787"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5883 41.582L56.0636 51.6759L64.8124 46.6289L47.3259 36.535L38.5883 41.582Z",
    fill: "#B9B9B9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0636 51.676C56.0636 58.635 53.7736 63.5597 50.1606 65.7385L58.8983 60.6916C62.5224 58.5127 64.8124 53.588 64.8124 46.629L56.0747 51.676H56.0636Z",
    fill: "#9F9F9F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1606 45.5505L32.6741 35.4566V12.145C42.3344 17.7256 50.1606 32.6775 50.1606 45.5505Z",
    fill: "#D7D7D7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4229 7.09814L32.6852 12.1451C35.8645 13.9793 38.8772 16.8363 41.4451 20.3047C46.6699 27.3527 50.1605 36.9241 50.1605 45.5506L58.8982 40.5037C58.8982 27.6306 51.0721 12.6676 41.4117 7.09814H41.4229Z",
    fill: "#D7D7D7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6741 12.145V35.4566L50.1606 45.5505L32.6741 35.4566V12.145Z",
    fill: "#84E0DD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4229 7.09814L32.6852 12.1451C35.8645 13.9793 38.8772 16.8363 41.4451 20.3047C46.6699 27.3527 50.1605 36.9241 50.1605 45.5506L58.8982 40.5037C58.8982 27.6306 51.0721 12.6676 41.4117 7.09814H41.4229Z",
    fill: "url(#paint4_linear_1352_358854)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6741 12.145V35.4566L50.1606 45.5505L32.6741 35.4566V12.145Z",
    fill: "#84E0DD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1352_358854",
    x1: 39.3938,
    y1: 77.0996,
    x2: 48.5952,
    y2: 61.2752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1352_358854",
    x1: 31.2178,
    y1: -1.95085,
    x2: 31.3401,
    y2: 7.44271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1352_358854",
    x1: 32.6741,
    y1: 32.9331,
    x2: 41.4229,
    y2: 32.9331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1352_358854",
    x1: 32.6519,
    y1: 44.9058,
    x2: 52.9731,
    y2: 44.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717",
    stopOpacity: 0.27
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1352_358854",
    x1: 30.4063,
    y1: 27.1192,
    x2: 51.9503,
    y2: 26.0076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7D7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartitionLarge);
export default __webpack_public_path__ + "static/media/partition-large.acbb708ebd229d19fe9f6807e6fc4d26.svg";
export { ForwardRef as ReactComponent };